import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";
import i18n from "i18n/i18next";

/**
 * Deeplink resolution screens. Only the resolver navigates here
 * (feat/deeplink/pendingDeeplink.ts); nothing in the UI links to them.
 */
export const linkRoutes: RouteRender[] = [
  lazyView(
    routes.link.noAccess,
    () => import("./no-access/link-no-access").then((m) => ({ default: m.LinkNoAccessPage })),
    () => i18n.t("deeplink.other-org-title"),
  ),
];
